const nodes = [
  { x: 160, y: 230, r: 3 },
  { x: 235, y: 640, r: 2 },
  { x: 330, y: 410, r: 2.5 },
  { x: 455, y: 175, r: 2 },
  { x: 520, y: 745, r: 3 },
  { x: 650, y: 300, r: 2 },
  { x: 690, y: 585, r: 2.5 },
  { x: 805, y: 142, r: 2 },
  { x: 880, y: 830, r: 2 },
  { x: 1020, y: 262, r: 3 },
  { x: 1120, y: 600, r: 2 },
  { x: 1240, y: 180, r: 2.5 },
  { x: 1305, y: 760, r: 2 },
  { x: 1460, y: 420, r: 3 },
  { x: 1515, y: 215, r: 2 },
  { x: 390, y: 860, r: 2 },
];

const edges = [
  [0, 3],
  [0, 2],
  [2, 3],
  [2, 5],
  [3, 5],
  [1, 2],
  [1, 4],
  [4, 6],
  [4, 7],
  [5, 7],
  [5, 8],
  [6, 8],
  [7, 9],
  [8, 10],
  [9, 10],
  [9, 11],
  [10, 12],
  [11, 12],
  [11, 13],
  [12, 13],
  [13, 14],
  [14, 15],
  [4, 15],
];

export function AmbientNetwork() {
  return (
    <svg className="ambient-network" viewBox="0 0 1600 1000" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <defs>
        <radialGradient id="ambient-fade" cx="50%" cy="47%" r="54%">
          <stop offset="0%" stopColor="var(--home-accent)" stopOpacity="0.12" />
          <stop offset="58%" stopColor="var(--home-accent)" stopOpacity="0.02" />
          <stop offset="100%" stopColor="var(--home-accent)" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="1600" height="1000" fill="url(#ambient-fade)" />
      <g className="ambient-lines">
        {edges.map(([from, to], index) => (
          <line
            key={`${from}-${to}`}
            x1={nodes[from].x}
            y1={nodes[from].y}
            x2={nodes[to].x}
            y2={nodes[to].y}
          />
        ))}
      </g>
      <g className="ambient-nodes">
        {nodes.map((node, index) => (
          <circle
            key={`${node.x}-${node.y}`}
            cx={node.x}
            cy={node.y}
            r={node.r}
          />
        ))}
      </g>
      <g className="ambient-rings">
        <circle cx="800" cy="470" r="250" />
        <circle cx="800" cy="470" r="390" />
        <circle cx="800" cy="470" r="540" />
      </g>
    </svg>
  );
}
